var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header'),_c('main',[_c('a',{attrs:{"href":"https://photos.zethlietzau.com/login"}},[_vm._v("Manage Photos")]),_c('h2',[_vm._v("Scrapbooks")]),_c('ScrapbookList'),_c('AddScrapbook')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }